// Like_Btn.js
import { faHeart as solidHeart } from "@fortawesome/free-solid-svg-icons";
import { faHeart as regularHeart } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './Like_Btn.css'

const Like_Btn = ({ isActive, onClick }) => {
  return (
    <div className='Like_Btn' onClick={onClick}>
      <FontAwesomeIcon
        icon={isActive ? solidHeart : regularHeart}
        className="heart_icon"
        style={{
          color: isActive ? "#E2177A" : "#000",
        }}
      />


    </div>
  )
}

export default Like_Btn
